import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import ReportsListPage from '@/pages/ReportsListPage';
import ReportFormPage from '@/pages/ReportFormPage';
import ReportDetailPage from '@/pages/ReportDetailPage';
import ReportEditPage from '@/pages/ReportEditPage';
import UserManagementPage from '@/pages/UserManagementPage';
import WeeklySummaryPage from '@/pages/WeeklySummaryPage';
import TasksAnalyticsPage from '@/pages/TasksAnalyticsPage';
import MyTasksPage from '@/pages/MyTasksPage';
import TimetablePage from '@/pages/TimetablePage';
import MyTimetablePage from '@/pages/MyTimetablePage';
import AllocationReportPage from '@/pages/AllocationReportPage';
import MainLayout from '@/components/MainLayout';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-slate-400 text-sm">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-slate-400 text-sm">Loading...</div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            <PublicRoute><LoginPage /></PublicRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute><MainLayout /></ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="reports" element={<ReportsListPage />} />
            <Route path="reports/new" element={<ReportFormPage />} />
            <Route path="reports/:id" element={<ReportDetailPage />} />
            <Route path="reports/:id/edit" element={<ReportEditPage />} />
            <Route path="users" element={<UserManagementPage />} />
            <Route path="weekly-summary" element={<WeeklySummaryPage />} />
            <Route path="tasks-analytics" element={<TasksAnalyticsPage />} />
            <Route path="my-tasks" element={<MyTasksPage />} />
            <Route path="timetable" element={<TimetablePage />} />
            <Route path="my-timetable" element={<MyTimetablePage />} />
            <Route path="allocation-report" element={<AllocationReportPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
